/* 
 * Développé par la société Précurseur.
 @copyright  Copyright (c) Précurseur
 @link       https://www.precurseur.fr
 */
import $ from 'jquery';
import Swiper from 'swiper/bundle';

export default class SectorMapSlider {

    constructor() {
        
        if($('.hd-sector-map__slider-map').length) {
            
            var hdSectorMapSliderMap = new Swiper(".hd-sector-map__slider-map", {
                grabCursor: true,
                slidePerView: 1,
                autoHeight: true, //enable auto height
                spaceBetween: 10,
            });
            
            $('.hd-sector-map__slider-nav__btn').on('click',function(e) {
                e.preventDefault();
                var slideIndex = $(this).attr('data-slide-index');
                if (typeof slideIndex  !== "undefined") {
                    hdSectorMapSliderMap.slideTo(slideIndex);
                }
            })
            
        }
    }
};
